"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigTargetingResponse = exports.ConfigTargetingResponseDebugData = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const config_result_1 = require("./config_result");
const benchmark_1 = require("./benchmark");
exports.protobufPackage = "snapchat.cdp.cof";
const baseConfigTargetingResponseDebugData = {
    abResultChecksumInput: "",
};
exports.ConfigTargetingResponseDebugData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.abResultChecksumInput !== "") {
            writer.uint32(10).string(message.abResultChecksumInput);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseConfigTargetingResponseDebugData);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.abResultChecksumInput = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseConfigTargetingResponseDebugData);
        if (object.abResultChecksumInput !== undefined &&
            object.abResultChecksumInput !== null) {
            message.abResultChecksumInput = object.abResultChecksumInput;
        }
        else {
            message.abResultChecksumInput = "";
        }
        return message;
    },
};
const baseConfigTargetingResponse = {
    configResultsEtag: "",
    fullResults: false,
    abResultChecksum: 0,
    iso3166Alpha2CountryCodeFromRequestIp: "",
};
exports.ConfigTargetingResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.configResults) {
            config_result_1.ConfigResult.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.configResultsEtag !== "") {
            writer.uint32(18).string(message.configResultsEtag);
        }
        if (message.benchmarkRequest !== undefined) {
            benchmark_1.BenchmarkRequest.encode(message.benchmarkRequest, writer.uint32(26).fork()).ldelim();
        }
        if (message.fullResults === true) {
            writer.uint32(32).bool(message.fullResults);
        }
        if (message.abResultChecksum !== 0) {
            writer.uint32(40).int32(message.abResultChecksum);
        }
        if (message.iso3166Alpha2CountryCodeFromRequestIp !== "") {
            writer.uint32(50).string(message.iso3166Alpha2CountryCodeFromRequestIp);
        }
        if (message.debugData !== undefined) {
            exports.ConfigTargetingResponseDebugData.encode(message.debugData, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseConfigTargetingResponse);
        message.configResults = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.configResults.push(config_result_1.ConfigResult.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.configResultsEtag = reader.string();
                    break;
                case 3:
                    message.benchmarkRequest = benchmark_1.BenchmarkRequest.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.fullResults = reader.bool();
                    break;
                case 5:
                    message.abResultChecksum = reader.int32();
                    break;
                case 6:
                    message.iso3166Alpha2CountryCodeFromRequestIp = reader.string();
                    break;
                case 7:
                    message.debugData = exports.ConfigTargetingResponseDebugData.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseConfigTargetingResponse);
        message.configResults = [];
        if (object.configResults !== undefined && object.configResults !== null) {
            for (const e of object.configResults) {
                message.configResults.push(config_result_1.ConfigResult.fromPartial(e));
            }
        }
        if (object.configResultsEtag !== undefined &&
            object.configResultsEtag !== null) {
            message.configResultsEtag = object.configResultsEtag;
        }
        else {
            message.configResultsEtag = "";
        }
        if (object.benchmarkRequest !== undefined &&
            object.benchmarkRequest !== null) {
            message.benchmarkRequest = benchmark_1.BenchmarkRequest.fromPartial(object.benchmarkRequest);
        }
        else {
            message.benchmarkRequest = undefined;
        }
        if (object.fullResults !== undefined && object.fullResults !== null) {
            message.fullResults = object.fullResults;
        }
        else {
            message.fullResults = false;
        }
        if (object.abResultChecksum !== undefined &&
            object.abResultChecksum !== null) {
            message.abResultChecksum = object.abResultChecksum;
        }
        else {
            message.abResultChecksum = 0;
        }
        if (object.iso3166Alpha2CountryCodeFromRequestIp !== undefined &&
            object.iso3166Alpha2CountryCodeFromRequestIp !== null) {
            message.iso3166Alpha2CountryCodeFromRequestIp =
                object.iso3166Alpha2CountryCodeFromRequestIp;
        }
        else {
            message.iso3166Alpha2CountryCodeFromRequestIp = "";
        }
        if (object.debugData !== undefined && object.debugData !== null) {
            message.debugData = exports.ConfigTargetingResponseDebugData.fromPartial(object.debugData);
        }
        else {
            message.debugData = undefined;
        }
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=config_response.js.map